function goBackHandler() {
  window.history.back();
}

module.exports = {
  addListeners() {
    $('body').on('click', '.btn--back', goBackHandler);
  },
};
